var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWeatherIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.5V3.1M2.6 10H1M4.4512 4.95137L3.31982 3.82M14.5498 4.95137L15.6812 3.82M18 10H16.4M5.50007 10.0001C5.50007 7.79093 7.29093 6.00007 9.50008 6.00007C11.0061 6.00007 12.3177 6.83235 13.0001 8.06206M5 22C2.79086 22 1 20.2091 1 18C1 15.7909 2.79086 14 5 14C5.46419 14 5.90991 14.0791 6.32442 14.2245C7.04061 12.3396 8.86387 11 11 11C13.1361 11 14.9594 12.3396 15.6756 14.2245C16.0901 14.0791 16.5358 14 17 14C19.2091 14 21 15.7909 21 18C21 20.2091 19.2091 22 17 22C12.3597 22 8.87921 22 5 22Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherIcon);
export default __webpack_public_path__ + "static/media/weather-icon.a2f6c2fbefbaba017e43b55bf57c0b44.svg";
export { ForwardRef as ReactComponent };